import React from 'react';
import NavigationBar from '../../components/NavigationBar/NavigationBar';

function Help() {
  return (
    <div>
      <NavigationBar />

      <main>
        <h1>Help</h1>
        <p>Text content goes here...</p>
      </main>
    </div>
  );
}

export default Help;
